import { CalendarDialog } from "@/components/CalendarDialog";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    step: "01",
    title: "Find the gaps",
    text: "We review your website, Google presence, reviews and lead handling to identify what is limiting results.",
  },
  {
    step: "02",
    title: "Fix what matters first",
    text: "We prioritise the improvements most likely to affect enquiries, trust and local visibility.",
  },
  {
    step: "03",
    title: "Measure and improve",
    text: "You receive straightforward reporting while we continue improving the areas that matter.",
  },
];

export function HowItWorksSection() {
  return (
    <section
      className="section-padding section-dark relative overflow-hidden"
      aria-labelledby="how-it-works-heading"
    >
      <div className="absolute inset-0 grid-pattern opacity-[0.07]" />
      <div className="container-wide relative z-10">
        <Reveal className="max-w-2xl mb-10 sm:mb-12">
          <span className="section-badge-dark mb-4">How It Works</span>
          <h2
            id="how-it-works-heading"
            className="heading-section text-foreground-dark mt-4 text-balance"
          >
            A simple process with{" "}
            <span className="heading-accent-dark">clear priorities</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
          {STEPS.map((item, i) => (
            <Reveal key={item.step} delay={0.06 * i} className="h-full">
              <article className="h-full rounded-2xl border border-white/10 bg-white/[0.05] p-6 sm:p-7 text-left">
                <div className="w-11 h-11 rounded-xl bg-primary text-primary-foreground flex items-center justify-center mb-4 font-bold text-base">
                  {item.step}
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-foreground-dark mb-2.5">
                  {item.title}
                </h3>
                <p className="text-base text-foreground-dark/80 leading-[1.7]">
                  {item.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <CalendarDialog
            buttonVariant="dark-primary"
            buttonSize="lg"
            buttonClassName="w-full sm:w-auto h-14 px-8 text-base font-bold rounded-xl"
            buttonText="Start With a Free Strategy Call"
          />
        </div>
      </div>
    </section>
  );
}
